import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "@/stores/auth";

const router = createRouter({
	history: createWebHistory(),
	routes: [
		{
			path: "/",
			redirect: "/products",
		},
		{
			path: "/login",
			name: "Login",
			component: () => import("@/views/Login.vue"),
			meta: { requiresAuth: false },
		},
		{
			path: "/products",
			name: "Products",
			component: () => import("@/views/Products.vue"),
			meta: { requiresAuth: true },
		},
		{
			path: "/products/:productId",
			name: "ProductDashboard",
			component: () => import("@/views/ProductDashboard.vue"),
			meta: { requiresAuth: true },
		},
		{
			path: "/products/:productId/roadmap",
			name: "Roadmap",
			component: () => import("@/views/Roadmap.vue"),
			meta: { requiresAuth: true },
		},
		{
			path: "/products/:productId/features/:featureId",
			name: "FeatureDetail",
			component: () => import("@/views/FeatureDetail.vue"),
			meta: { requiresAuth: true },
		},
		{
			path: "/products/:productId/review",
			name: "FeatureReview",
			component: () => import("@/views/FeatureReview.vue"),
			meta: { requiresAuth: true },
		},
		{
			path: "/products/:productId/artifacts/:artifactId",
			name: "ArtifactReview",
			component: () => import("@/views/ArtifactReview.vue"),
			meta: { requiresAuth: true },
		},
		{
			path: "/products/:productId/destinations",
			name: "PublishDestinations",
			component: () => import("@/views/PublishDestinations.vue"),
			meta: { requiresAuth: true },
		},
		{
			path: "/products/:productId/destinations/:destinationId/browse",
			name: "DestinationBrowser",
			component: () => import("@/views/DestinationBrowser.vue"),
			meta: { requiresAuth: true },
		},
		{
			path: "/products/:productId/destinations/:destinationId/preview",
			name: "HostedDocsPreview",
			component: () => import("@/views/HostedDocsPreview.vue"),
			meta: { requiresAuth: true },
		},
		{
			path: "/products/:productId/environments",
			name: "Environments",
			component: () => import("@/views/Environments.vue"),
			meta: { requiresAuth: true },
		},
		{
			path: "/products/:productId/review-queue",
			name: "ReviewQueue",
			component: () => import("@/views/ReviewQueue.vue"),
			meta: { requiresAuth: true },
		},
		{
			path: "/products/:productId/manage",
			name: "ManageProduct",
			component: () => import("@/views/ManageProduct.vue"),
			meta: { requiresAuth: true },
		},
		{
			path: "/manage",
			name: "Manage",
			component: () => import("@/views/Manage.vue"),
			meta: { requiresAuth: true },
		},
		{
			path: "/audience-profiles",
			name: "AudienceProfiles",
			component: () => import("@/views/AudienceProfiles.vue"),
			meta: { requiresAuth: true },
		},
		{
			path: "/verify-publications",
			name: "VerifyPublications",
			component: () => import("@/views/VerifyPublications.vue"),
			meta: { requiresAuth: true },
		},
		{
			path: "/artifact-types",
			name: "ArtifactTypes",
			component: () => import("@/views/ArtifactTypes.vue"),
			meta: { requiresAuth: true },
		},
		{
			path: "/profile",
			name: "Profile",
			component: () => import("@/views/Profile.vue"),
			meta: { requiresAuth: true },
		},
		{
			path: "/usage",
			name: "ApiUsage",
			component: () => import("@/views/ApiUsage.vue"),
			meta: { requiresAuth: true },
		},
		{
			path: "/changelog",
			name: "Changelog",
			component: () => import("@/views/Changelog.vue"),
			meta: { requiresAuth: true },
		},
		{
			path: "/settings",
			name: "Settings",
			component: () => import("@/views/Profile.vue"), // Reusing Profile for now
			meta: { requiresAuth: true },
		},
		{
			path: "/:pathMatch(.*)*",
			name: "NotFound",
			component: () => import("@/views/NotFound.vue"),
		},
	],
});

// Navigation guard
router.beforeEach(async (to, from, next) => {
	const authStore = useAuthStore();

	// Check if route requires authentication
	if (to.meta.requiresAuth) {
		// Check if user is authenticated
		if (!authStore.isAuthenticated) {
			// Try to check auth status from server
			await authStore.checkAuthStatus();

			if (!authStore.isAuthenticated) {
				next("/login");
				return;
			}
		}
	}

	// If user is authenticated and trying to access login page, redirect to products
	if (to.name === "Login" && authStore.isAuthenticated) {
		next("/products");
		return;
	}

	next();
});

export default router;
